import { State } from '@/types/store/state';

export const state: State = {
    apiUrl: '',
    siteName: '',
    periods: [],
    frequencies: [],
    notificationData: {
        frequency: null,
        period: null
    },
    isLoading: true,
    isSubmitting: false,
    hasApiError: false,
    email: '',
    rememberDetails: false,
    needFocusEmail: false,
    error: '',
    isEmailError: false,
    showIncludeUk: false
};
